import classNames from 'classnames';

import { Typography } from '@/shared/components/atoms';

import EditIcon from '~/images/shared/edit.svg';

const ReviewCard: React.FC<{
  header: string | React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
  px?: string;
  py?: string;
  cols?: string;
  borderedHeader?: boolean;
  headerBg?: string;
}> = ({
  header,
  children,
  onClick,
  px = 'px-24',
  py = 'py-16',
  cols = 'grid-cols-2',
  borderedHeader,
  headerBg,
}) => {
  return (
    <div
      className={classNames(
        headerBg,
        borderedHeader && 'rounded-xl border-xs border-neutralVariant-90'
      )}
    >
      <div className='flex items-center gap-16'>
        <Typography
          variant='h3'
          weight='semiBold'
          className={classNames(borderedHeader && ['mt-16', px])}
        >
          {header}
        </Typography>
        {onClick && (
          <span
            className='cursor-pointer text-primary-default'
            onClick={onClick}
          >
            <EditIcon width='24' height='24' />
          </span>
        )}
      </div>
      <div
        className={classNames(
          'mt-16 grid justify-between gap-y-16 gap-x-32 overflow-hidden border-neutralVariant-90 bg-white',
          borderedHeader ? 'rounded-b-xl border-t-xs' : 'rounded-xl border-xs',
          px,
          py,
          cols
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default ReviewCard;
